<template>
	<v-card elevation="4" class="rounded-lg">
		<v-card-title class="grey " style="padding: 1%;">
			<span style="color: #f1f1f1; margin-left: 15px;">Proyectos</span>
			<v-btn icon @click="$emit('openResultDialog')" color="white">
				<v-icon>mdi-chart-bar</v-icon>
			</v-btn>
			<v-btn icon @click="$emit('openActiveProcessDialog')" color="white" v-if="$fun.isAdmin()">
				<v-icon>mdi-circle-edit-outline</v-icon>
			</v-btn>
		</v-card-title>
		<!-- Filtros -->
		<v-card-text class="pb-0 pl-0 pr-0">
			<v-chip-group :value="selectedFilter" mandatory show-arrows center-active
				class="px-4 pl-1 pr-1" @change="onFilterChange">
				<v-chip small v-for="filter in filters" :key="filter.value" :value="filter.value"
					variant="flat" :color="selectedFilter === filter.value ? 'primary' : 'default'">
					{{ filter.label }}
				</v-chip>
			</v-chip-group>
		</v-card-text>
		<v-list :lines="false" density="compact" nav dense class="scrollable">
			<v-list-item-group :value="selectedProject ? selectedProject.TkpID : null">
				<v-list-item v-for="project in projects" :key="project.TkpID"
					@click="onProjectSelect(project)" :value="project.TkpID" color="info">
					<v-list-item-icon>
						<v-icon>mdi-laptop</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>{{ project.TkpTitle }}</v-list-item-title>
					</v-list-item-content>
					<v-chip x-small color="success" v-if="project.TypeNivelUsr == 1">
						{{ project.TypeNivelUsrName }}
					</v-chip>
				</v-list-item>
			</v-list-item-group>
		</v-list>
	</v-card>
</template>

<script>
export default {
    name: 'ProjectSidebar',
    props: {
        projects: {
            type: Array,
            default: () => []
        },
        filters: {
            type: Array,
            default: () => []
        },
        selectedFilter: {
            type: Number,
            default: 2
        },
        selectedProject: {
            type: Object,
            default: null
        }
    },
    methods: {
        onFilterChange(value) {
            if (value !== undefined && value !== null) {
                this.$emit('filter-changed', value);
            }
        },
        onProjectSelect(project) {
            this.$emit('project-selected', project);
        }
    }
}
</script>

<style scoped>
.scrollable {
	max-height: 450px;
	overflow-y: auto;
}
.rounded-lg {
    border-radius: 8px !important;
}
</style>
